import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-zinc-950 text-white py-12 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          <div>
            <h4 className="text-2xl font-serif mb-4 tracking-widest">SIXONE<span className="text-gold">PRODUCTIONS</span></h4>
            <p className="text-gray-400 text-sm leading-relaxed">Transforming ideas into spectacular realities. Your trusted partner in luxury event management and design.</p>
          </div>
          <div>
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#home" className="hover:text-gold transition">Home</a></li>
              <li><a href="#about" className="hover:text-gold transition">About Us</a></li>
              <li><a href="#services" className="hover:text-gold transition">Services</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xl font-semibold mb-4">Contact</h4>
            <p className="text-gray-400 text-sm mb-2">6.oneproductions@gmail.com</p>
            <p className="text-gray-400 text-sm">+91 8510815101 </p>
            <p className="text-gray-400 text-sm">+91 9811779965 </p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
          <p className="text-sm">&copy; {new Date().getFullYear()} SIXONEPRODUCTIONS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;